export default [{
	titulo: 'Situação Equipamento',
	icone: 'menu-icon fa fa-caret-right',
	url: '/admin/situacao',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]